import React from 'react'
import Link from '@components/ui/Link'
import { getLink } from '@helpers/env'
import HeaderLogo from '@components/Header/shared/HeaderLogo'
import Translations from '@helpers/translations'
import styles from './styles.module.scss'

const ReturnsHeader = () => {
  return (
    <div className={styles.header}>
      <div className={styles.headerItem}>
        <Link
          classes={styles.header__help}
          href={getLink('/pages/contact-us')}
          text={Translations.localise('pages.returns.need-help')}
          target="_blank"
          rel="noopener noreferrer"
        />
      </div>
      <div className={styles.headerItem}>
        <HeaderLogo width="87" height="50" className={styles.header__logo} />
      </div>
      <div className={styles.headerItem__link}>
        <Link
          classes={styles.header__linkDesktop}
          href="/"
          text={Translations.localise('pages.returns.shop-the-store')}
        />
        <Link
          classes={styles.header__linkMobile}
          href="/"
          text={Translations.localise('pages.returns.shop')}
        />
      </div>
    </div>
  )
}

export default ReturnsHeader
